import React from "react"
import { withStyles } from "@material-ui/core/styles"
import classNames from "classnames"
import CancelIcon from "@material-ui/icons/Cancel"

import amber from "@material-ui/core/colors/amber"

const styles = theme => ({
  chipRoot: {
    border: "none",
    cursor: "default",
    padding: "0",
    display: "inline-flex",
    outline: "none",
    transition:
      "background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    whiteSpace: "nowrap",
    alignItems: "center",
    fontFamily: "Open Sans,sans-serif",
    borderRadius: 16,
    textDecoration: "none",
    justifyContent: "center",
  },
  chip: {
    backgroundColor: amber[400],
    color: "#fff",
    fontSize: "0.7125rem",
    height: 25,
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
    textTransform: "uppercase",
  },
  chipLabel: {
    cursor: "inherit",
    display: "flex",
    alignItems: "center",
    userSelect: "none",
    whiteSpace: "nowrap",
    paddingLeft: 12,
  },
  spacing: {
    paddingRight: 12,
  },
  positionRate: {
    fontWeight: 700,
    display: "inline-block",
    marginLeft: theme.spacing(1),
    paddingRight: 12,
  },
  deleteIcon: {
    width: "0.9em",
    cursor: "pointer",
    marginRight: 2,
    marginLeft: -6,
  },
})

const PositionChip = ({ position, rate, classes, canRemove, onDelete }) => (
  <div
    role="button"
    className={classNames(classes.chipRoot, classes.chip)}
    tabIndex={-1}
  >
    <span
      className={classNames(classes.chipLabel, { [classes.spacing]: !rate })}
    >
      {position}
    </span>
    {rate !== undefined &&
      rate !== 0 &&
      rate !== null &&
      rate !== "" && <span className={classes.positionRate}>${rate}</span>}
    {canRemove && (
      <CancelIcon
        className={classes.deleteIcon}
        onTouchEnd={onDelete}
        onClick={onDelete}
      />
    )}
  </div>
)

export default withStyles(styles, { withTheme: true })(PositionChip)
